import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          <div className="md:col-span-2">
            <h3 className="text-3xl font-bold mb-4">UPGRADED VERSION</h3>
            <p className="text-gray-400 mb-6 max-w-md leading-relaxed">
              Professional Airbnb management and coaching services built in Lagos, proven everywhere. We help hosts maximize revenue and deliver 5-star guest experiences.
            </p>
          </div>

          <div>
            <h4 className="text-sm font-bold uppercase mb-4 text-gray-300">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/services" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/coaching" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Coaching
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  FAQ
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Blog
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold uppercase mb-4 text-gray-300">Contact</h4>
            <ul className="space-y-3 text-gray-400">
              <li className="flex items-start">
                <i className="ri-mail-line mr-2 mt-1"></i>
                <span>info@upgradedversion.com</span>
              </li>
              <li className="flex items-start">
                <i className="ri-phone-line mr-2 mt-1"></i>
                <span>+1 443 787 18881</span>
              </li>
              <li className="flex items-start">
                <i className="ri-map-pin-line mr-2 mt-1"></i>
                <span>1942 Broadway Street, Suite 314C,<br />Boulder, Colorado 80302, USA</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-sm text-gray-400 mb-4 md:mb-0">
            © 2025 Upgraded Version. All rights reserved.
          </p>
          <div className="flex space-x-6">
            <Link to="/privacy" className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">
              Privacy Policy
            </Link>
            <Link to="/terms" className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}